import { useEffect, useRef, useState } from "react"
import { useSnapshot } from "valtio"
import { dsrstatic_Air, dsrstatic_Air_keys, dsrstatic_FCLFactoryFactory, dsrstatic_FCLFactoryFactory_keys, dsrstatic_cn, dsrstatic_LCL, dsrstatic_LCL_keys ,dsrstatic_FCLDockDock, dsrstatic_FCLDockDock_keys, dsrstatic_FCLDockFactory, dsrstatic_FCLDockFactory_keys, dsrstatic_FCLFactoryDock, dsrstatic_FCLFactoryDock_keys, OCEAN_TRACKING_DSR_KEYS} from "../my-actions/dsr_static"
import { taskStore } from "./task-store"
import Taskapi from "./tasks-api";
import MonApi, { GET_BOOKINGDSR_BY_FILTER_URI, GET_PENDING_MYACTIONS_URI } from "../state/mongo-api";
import { AgmodalStore, bookingsStore, configStore, dataListStore, loginStore } from "../state/CommonState";
import Api from "../state/Api";
import { myactionsstore } from "../my-actions/store-myactions";
import Utils from "../util/Utils";
import { Popup } from "../masterJob/createMasterJob";
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS_NEW, SHIPMENT_SCOPE, SHIPMENT_TYPE } from "../util/constants";
import TenantUtils from "../util/tenant.utils";
import { getStaticConsolidatorList } from "../StaticData";
import on from '../components/on2.png'
import off from '../components/off.png'
import { OneInput5table } from "./act-common";
import airlineCodes from "../static-data/airlines";

const visibilityFieldName = "visibilityFields"
const containerReferenceFieldName = "visibilityContainerReferenceKeys"
const containerVisibilityFieldName = "visibilityContainerFields"
const containerFieldPrefix = "containerlist."
// Built on each call: the consolidator list loads from the server after this module is imported
const consolidatorOptions = () => getStaticConsolidatorList().map((item) => ({
    label: `${item.consolidatorAbbrName} (${item.scacCode})`,
    value: item.consolidatorAbbrName,
}))
const getOptionsValue = (key, carrierList = []) => {
    const fieldKey = String(key || "").split(".").pop().toLowerCase()
    if (fieldKey === "consolidator") return consolidatorOptions()
    if (fieldKey === "containertype") return [`20'STD`, `40'STD`, `40'HC`, `45'HC`, `20'FR (In-gauge)`, `40'FR (In-gauge)`,
        `20'OT (In-gauge)`, `40'OT (In-gauge)`, `20'OT (Out-gauge)`, `40'OT (Out-gauge)`, `20'FR (Out-gauge)`, `40'FR (Out-gauge)`
    ].map((type) => ({ label: type, value: type }))
    if (fieldKey === "new_carrier_name"){
        return dataListStore['FCLCarrierList'].map(carrier => ({ label: carrier['Display Name'], value: `${carrier['Display Name']} (${carrier['SCAC code']})` })) 
    }
    if (fieldKey === "carrier" && taskStore.current.shipmentType.toLowerCase() !== 'air'){
        return dataListStore['FCLCarrierList'].map(carrier => ({ label: carrier['Display Name'], value: `${carrier['Display Name']} (${carrier['SCAC code']})` })) 
    }
    if (fieldKey === "carrier" && taskStore.current.shipmentType.toLowerCase() === 'air'){
        return airlineCodes.map(air => ({ label: air.name, value: air.code }))
    }
    if (fieldKey === "mlo") {
        return carrierList
            .filter((carrier) => carrier?.["MLO or NVOCC"] !== "NVOCC")
            .map((carrier) => ({
                label: carrier["Display Name"],
                value: `${carrier["Display Name"]} (${carrier["SCAC code"]})`,
            }))
    }
    return []
}

const dsrFieldTypes = {
    delivery_order_status:"toggle",
    reworking_at_pod:"toggle",
    reworking_at_pol:"toggle",
    cargo_picked_up_by_consignee:"date",
    consolidator: "select",
    mlo :"select",
    containerType: "select",
    new_carrier_name: "select",
    carrier:"select",
    vgm_cut_off: "datetime",
    shipping_instructions_cut_off: "datetime",
    shipbill_cutoff: "datetime",
    container_gate_cut_off: "datetime",
    gate_opening: "datetime",
    ams_cutoff: "datetime",
    isf_cutoff: "datetime",
    gate_cut_off: "datetime",
    container_arrival_factory: "date",
    empty_container_arrival_at_por: "date",
    stuffing_confirmation: "date",
    cargo_gatein_CFS: "date",
    carrier_booking_release:"date",
    etd_at_pol: "date",
    sob_pol: "date",
    ts1_arrival_estimate: "date",
    ts1_arrival: "date",
    ts1_departure_estimate: "date",
    ts1_departure: "date",
    ts2_arrival_estimate: "date",
    ts2_arrival: "date",
    ts2_departure_estimate: "date",
    ts2_departure: "date",
    ts3_arrival_estimate: "date",
    ts3_arrival: "date",
    ts3_departure_estimate: "date",
    ts3_departure: "date",
    ts4_arrival_estimate: "date",
    ts4_arrival: "date",
    ts4_departure_estimate: "date",
    ts4_departure: "date",
    arrival_notice: "date",
    eta_at_pod: "date",
    pod_arrival: "date",
    etd_pod: "date",
    gateout_to_fpod: "date",
    eta_fpod: "date",
    gatein_fpod: "date",
    last_free_date_at_fpod: "date",
    delivery_order_release: "date",
    destuffing_reworking:"date",
    restuffing_reworking:"date",
    reworking_pol_destuffing:"date",
    reworking_pol_restuffing:"date",
    reworking_pod_destuffing:"date",
    reworking_pod_restuffing:"date",
    cargo_cutoff: "datetime",
    leo_cutoff: "datetime",
    stuffing_cutoff: "datetime",
    pol_arrival: "date",
    reworking_pol_arrival_estimate: "date",
    reworking_pol_arrival: "date",
    reworking_pol_departure_estimate: "date",
    reworking_pol_departure: "date",
    reworking_pod_arrival_estimate: "date",
    reworking_pod_arrival: "date",
    reworking_pod_departure_estimate: "date",
    reworking_pod_departure: "date",
    reworking_departure_estimate: "date",
    sob_reworking: "date",
    reworking_departure_actual: "date",
    destuffing_fpod: "date",
    gatein_pol: "date",
    estimate_delivery_date_to_consignee: "date",
    container_de_vanning: "date",
    container_arrival_at_fpod: "date",
    container_delivery: "date",
    container_pickup_fpod: "date",
    arrival_factory: "date",
    container_handover:"date",
    cargo_pickup: "date",
    cargo_arrival_cfs: "date",
    loaded_cfs: "date",
    atdfrompod: "date",
    actual_delivery_date: "date",
    empty_container_arrival_at_factory: "date",
    loaded_and_dispatched: "date",
    loaded_and_dispatch: "date",
    gate_in_at_pol: "date",
    container_pickup_at_fpod: "date",
    container_delivered_to_consignee: "date",
    arrival_dispatch_airport: "date",
    dispatched_from_arrival_airport: "date",
    rail_yard_to_cfs:"date",
    por_to_pol_movement: "date",
    destuffing_at_pol: "date",
    restuffing_at_pol: "date",
    empty_container_pickup:"date",
    airline_booking_release:"date",
    etd_airport_of_departure:"date",
    loaded_on_board:"date",
    eta_at_arrival_airport:"date",
    ata_at_arrival_airport:"date",
    "Shipping Bill Date":"date",
    "Shipping Bill Checklist":"date",
    "Let-Export-Order Date":"datetime",
    "Bill of Entry Date":"date",
    "Out of Charge Date":"date",
    "Submission to Customs Date":"date",
    "container_discharged_pod":"date",
    "container_arrived_cfs":"date",
    "terminal_drayage_out": "date",
    "loaded_for_inland": "date",
    "cargo_available_at_cfs": "date",
    "fpod_customs_release": "date",
    "destination_freight_release": "date",
    "inbond_submitted_date": "date",
    "inbond_arrived_date": "date",
    "go_date_pod": "date",
    "go_date_fpod": "date",
    "Customs Entry":"date",
    "Customs Clearance Complete":"date",
    "Cleared for export": "date",
    "Bill of Entry Checklist": "date"
}

const exportIndia = [{
    label: "Shipping Bill Checklist",
    value: ""
}, {
    label: "Shipping Bill Number",
    value: ""
}, {
    label: "Shipping Bill Date",
    value: ""
}, {
    label: "Let-Export-Order Date",
    value: ""
}]

const customClearanceFieldPrefix = "customClearance:"
const createCustomClearanceFieldKey = (recordKey, index, label) => (
    `${customClearanceFieldPrefix}${recordKey}:${index}:${encodeURIComponent(label)}`
)
const parseCustomClearanceFieldKey = (fieldKey) => {
    if (!fieldKey.startsWith(customClearanceFieldPrefix)) return null
    const [recordKey, index, encodedLabel] = fieldKey
        .slice(customClearanceFieldPrefix.length)
        .split(":")
    return {
        recordKey,
        index: Number(index),
        label: decodeURIComponent(encodedLabel || ""),
    }
}
const getExportClearanceRecordKeys = (record) => Object.keys(record || {})
    .filter((key) => /^exportClearance\d*$/.test(key))
    .sort((left, right) => {
        const leftIndex = Number(left.match(/\d+$/)?.[0] || 1)
        const rightIndex = Number(right.match(/\d+$/)?.[0] || 1)
        return leftIndex - rightIndex
    })

const exportNonIndia = [{
    label: "Customs Entry",
    value: ""
}, {
    label: "Customs Reference Number",
    value: ""
}, {
    label: "Submission to Customs Date",
    value: ""
}, {
    label: "Cleared for export",
    value: ""
}]

const importIndia = [{
    label: "Bill of Entry Checklist",
    value: ""
}, {
    label: "Bill of Entry Number",
    value: ""
}, {
    label: "Bill of Entry Date",
    value: ""
}, {
    label: "Out of Charge Date",
    value: ""
}]

const importNonIndia = [{
    label: "Customs Entry",
    value: ""
}, {
    label: "Customs Reference Number",
    value: ""
}, {
    label: "Submission to Customs Date",
    value: ""
}, {
    label: "Customs Clearance Complete",
    value: ""
}]


const origin_pickup_LCL = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
};

const origin_pickup_LCL_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "arrival_factory",
    "cargo_pickup",
    "cargo_arrival_cfs",
]

const destination_delivery_LCL = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Cargo Picked-up for Delivery",
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_LCL_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "loaded_cfs",
    "atdfrompod",
    "estimate_delivery_date_to_consignee",
    "actual_delivery_date",
]
const origin_pickup_fcl_FACTORY_FACTORY = {
    empty_container_arrival_at_factory: "Empty container arrival at factory",
    loaded_and_dispatched: "loaded and dispatched",
    gate_in_at_pol: "Gate-in @ POL",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const origin_pickup_fcl_FACTORY_FACTORY_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "empty_container_arrival_at_factory",
    "loaded_and_dispatched",
    "gate_in_at_pol",
    "container_number_vehicle"
]
const destination_delivery_fcl_FACTORY_FACTORY = {
    container_pickup_at_fpod: "Container pickup @ FPOD",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    container_delivered_to_consignee: "Container delivered to consignee",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_fcl_FACTORY_FACTORY_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "container_pickup_at_fpod",
    "estimate_delivery_date_to_consignee",
    "container_delivered_to_consignee",
    "container_number_vehicle"
]
const origin_pickup_fcl_FACTORY_CFS = {
    empty_container_arrival_at_factory: "Empty container arrival at factory",
    loaded_and_dispatched: "loaded and dispatched",
    gate_in_at_pol: "Gate-in @ POL",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const origin_pickup_fcl_FACTORY_CFS_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "empty_container_arrival_at_factory",
    "loaded_and_dispatched",
    "gate_in_at_pol",
    "container_number_vehicle"
]
const destination_delivery_fcl_FACTORY_CFS = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Dispatched from CFS",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    actual_delivery_date: "Actual delivery date",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_fcl_FACTORY_CFS_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "loaded_cfs",
    "atdfrompod",
    "estimate_delivery_date_to_consignee",
    "actual_delivery_date",
    "container_number_vehicle",
]
const origin_pickup_fcl_CFS_CFS = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const origin_pickup_fcl_CFS_CFS_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "arrival_factory",
    "cargo_pickup",
    "cargo_arrival_cfs",
]
const destination_delivery_fcl_CFS_CFS = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Dispatched from CFS",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    actual_delivery_date: "Actual delivery date",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_fcl_CFS_CFS_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "loaded_cfs",
    "atdfrompod",
    "estimate_delivery_date_to_consignee",
    "actual_delivery_date",
    "container_number_vehicle",
]
const origin_pickup_fcl_CFS_FACTORY = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const origin_pickup_fcl_CFS_FACTORY_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "arrival_factory",
    "cargo_pickup",
    "cargo_arrival_cfs",
]
const destination_delivery_fcl_CFS_FACTORY = {
    container_pickup_at_fpod: "Container pickup @ FPOD",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    container_delivered_to_consignee: "Container delivered to consignee",
    container_number_vehicle: "Container Number",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_fcl_CFS_FACTORY_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "container_pickup_at_fpod",
    "estimate_delivery_date_to_consignee",
    "container_delivered_to_consignee",
    "container_number_vehicle"
]
const origin_pickup_AIR = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    arrival_dispatch_airport: "Arrival @ Dispatch Airport",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const origin_pickup_AIR_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "arrival_factory",
    "cargo_pickup",
    "arrival_dispatch_airport",
]
const destination_delivery_AIR = {
    dispatched_from_arrival_airport: "Dispatched from Arrival Airport	",
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
    driver_number: "Driver Number",
    driver_name: "Driver Name",
    vehicle: "Vehicle Number",
    number_of_package: "Number of Package",
    transport_name: "Transporter Name",
    transport_ref_number: "Transporter Ref Number",
}
const destination_delivery_AIR_Keys = [
    "transport_ref_number",
    "transport_name",
    "driver_number",
    "driver_name",
    "vehicle",
    "number_of_package",
    "dispatched_from_arrival_airport",
    "estimate_delivery_date_to_consignee",
    "actual_delivery_date",
]

const createVisibilityFieldMetadata = (fieldKeys) => fieldKeys.map((key) => {
    const parsedKey = parseCustomClearanceFieldKey(key)
    const label = parsedKey?.label || key
    return {
        key,
        dataType: dsrFieldTypes[label] || dsrFieldTypes[key] || "input",
    }
})

const visibilityFieldMetadata = {
    "FCL (Factory/Factory)": createVisibilityFieldMetadata(dsrstatic_FCLFactoryFactory_keys),
    "FCL (Dock/Factory)": createVisibilityFieldMetadata(dsrstatic_FCLDockFactory_keys),
    "FCL (Factory/Dock)": createVisibilityFieldMetadata(dsrstatic_FCLFactoryDock_keys),
    "FCL (Dock/Dock)": createVisibilityFieldMetadata(dsrstatic_FCLDockDock_keys),
    LCL: createVisibilityFieldMetadata(dsrstatic_LCL_keys),
    AIR: createVisibilityFieldMetadata(dsrstatic_Air_keys),
}

const transportFieldLabelsByShipmentType = {
    "FCL (Factory/Factory)": {
        origin: origin_pickup_fcl_FACTORY_FACTORY,
        destination: destination_delivery_fcl_FACTORY_FACTORY,
    },
    "FCL (Dock/Factory)": {
        origin: origin_pickup_fcl_CFS_FACTORY,
        destination: destination_delivery_fcl_CFS_FACTORY,
    },
    "FCL (Factory/Dock)": {
        origin: origin_pickup_fcl_FACTORY_CFS,
        destination: destination_delivery_fcl_FACTORY_CFS,
    },
    "FCL (Dock/Dock)": {
        origin: origin_pickup_fcl_CFS_CFS,
        destination: destination_delivery_fcl_CFS_CFS,
    },
    LCL: { origin: origin_pickup_LCL, destination: destination_delivery_LCL },
    lcl: { origin: origin_pickup_LCL, destination: destination_delivery_LCL },
    Air: { origin: origin_pickup_AIR, destination: destination_delivery_AIR },
    AIR: { origin: origin_pickup_AIR, destination: destination_delivery_AIR },
    air: { origin: origin_pickup_AIR, destination: destination_delivery_AIR },
}

export default function VisibilityUpdate() {
    const carrierList = useSnapshot(dataListStore).FCLCarrierList || []
    const [values, setValues] = useState(taskStore.current?.visibilityValues || {})
    const [recordLabels, setRecordLabels] = useState({})
    const [saving, setSaving] = useState(false)
    const [open, setOpen] = useState(false)
    const shipmentType = taskStore.current?.shipmentType || ""
    const isContainerDetails = taskStore.current?.visibilityUpdateTrigger === "Container Details"
    const isOriginCustom = taskStore.current?.visibilityUpdateTrigger === "Origin Custom"
    const isDestinationCustom = taskStore.current?.visibilityUpdateTrigger === "Destination Custom"
    const isCustomClearance = isOriginCustom || isDestinationCustom
    const isOriginTransport = taskStore.current?.visibilityUpdateTrigger === "Origin Transport"
    const isDestinationTransport = taskStore.current?.visibilityUpdateTrigger === "Destination Transport"
    const isTransportUpdate = isOriginTransport || isDestinationTransport
    const transportFieldName = isOriginTransport ? "vorgin" : isDestinationTransport ? "vdes" : ""
    const transportFieldLabels = transportFieldLabelsByShipmentType[shipmentType]
        ?.[isOriginTransport ? "origin" : "destination"] || {}
    const selectedKeys = taskStore.current?.[visibilityFieldName] || []
    const referenceKeys = taskStore.current?.referenceKey || []
    const containerReferenceKeys = taskStore.current?.[containerReferenceFieldName] || []
    const containerSelectedKeys = taskStore.current?.[containerVisibilityFieldName] || []
    const actionKeys = selectedKeys.filter((key) => !referenceKeys.includes(key))
    const containerActionKeys = containerSelectedKeys.filter((key) => !containerReferenceKeys.includes(key))
    const containerDisplayedKeys = [...new Set([...containerReferenceKeys, ...containerSelectedKeys])]
    const displayedKeys = [...new Set([...referenceKeys, ...selectedKeys])]
    const displayedKeySignature = displayedKeys.join(",")
    const containerDisplayedKeySignature = containerDisplayedKeys.join(",")
    const shipmentFieldMetadata = visibilityFieldMetadata[shipmentType]
        || (shipmentType.toLowerCase().includes("lcl") ? visibilityFieldMetadata.LCL : visibilityFieldMetadata.AIR)
        || []
    const fieldMetadata = isContainerDetails || isTransportUpdate || isCustomClearance
        ? createVisibilityFieldMetadata(displayedKeys)
        : [
            ...shipmentFieldMetadata,
            ...createVisibilityFieldMetadata(displayedKeys.filter((key) => (
                !shipmentFieldMetadata.some(({ key: metadataKey }) => metadataKey === key)
            ))),
        ]
    const labels = isCustomClearance
        ? Object.fromEntries(displayedKeys.map((key) => {
            const parsedKey = parseCustomClearanceFieldKey(key)
            return [key, parsedKey?.label || key]
        }))
        : isTransportUpdate
            ? transportFieldLabels
            : isContainerDetails
                ? dsrstatic_cn
                : shipmentType.toLowerCase().includes("lcl")
                    ? dsrstatic_LCL
                    : shipmentType.toLowerCase().includes("air")
                        ? dsrstatic_Air
                        : shipmentType === "FCL (Factory/Factory)"
                            ? dsrstatic_FCLFactoryFactory
                            : shipmentType === "FCL (Dock/Factory)"
                                ? dsrstatic_FCLDockFactory
                                : shipmentType === "FCL (Factory/Dock)"
                                    ? dsrstatic_FCLFactoryDock
                                    : dsrstatic_FCLDockDock
    const labelsRef = useRef(labels)
    labelsRef.current = labels
    const displayLabels = {
        ...labels,
        reworking_at_pol: "Re-working at POL ?",
        reworking_at_pod: "Re-working at POD ?",
        eta_at_pod: "ETA @ POD",
        pod_arrival:"ATA @ POD",
        loaded_cfs:"Loaded @ CFS",
        ...recordLabels,
    }
    const hasVisibilityValue = (value) => {
        if (value === undefined || value === null) return false
        if (typeof value === "string") return value.trim().length > 0
        if (Array.isArray(value)) return value.length > 0
        if (typeof value === "object") return Object.keys(value).length > 0
        return true
    }
    const isFormComplete = (() => {
        if (isContainerDetails || isTransportUpdate) {
            const rows = isContainerDetails ? values.containerlist || [] : values.transportRecords || []
            return actionKeys.length > 0
                && rows.length > 0
                && rows.every((row) => actionKeys.every((key) => hasVisibilityValue(row?.[key])))
        }

        const rootFieldsComplete = actionKeys.every((key) => hasVisibilityValue(values[key]))
        const containerFieldsComplete = containerActionKeys.length === 0
            || ((values.containerlist || []).length > 0
                && values.containerlist.every((container) => (
                    containerActionKeys.every((key) => hasVisibilityValue(container?.[key]))
                )))

        return (actionKeys.length > 0 || containerActionKeys.length > 0)
            && rootFieldsComplete
            && containerFieldsComplete
    })()
    useEffect(() => {
        async function loadVisibilityValues() {
            const dsr = await MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, {
                _id: bookingsStore.current?._id,
            })
            const record = Array.isArray(dsr) ? dsr[0] : {}
            if (taskStore.current?.visibilityUpdateTrigger === "P2P" && taskStore.current.shipmentType!='Air') {
                setRecordLabels(myactionsstore.addts({ ...labelsRef.current }, record))
            } else if (taskStore.current?.visibilityUpdateTrigger === "P2P" && taskStore.current.shipmentType=='Air') {
                setRecordLabels(myactionsstore.addairts({ ...labelsRef.current }, record))
            } else {
                setRecordLabels({})
            }
            const keysToLoad = displayedKeySignature ? displayedKeySignature.split(",") : []
            const containerKeysToLoad = containerDisplayedKeySignature
                ? containerDisplayedKeySignature.split(",")
                : []
            const currentTransportFieldName = isOriginTransport
                ? Array.isArray(record?.vorgin) ? "vorgin" : "vorgin"
                : transportFieldName
            const savedValues = taskStore.current?.visibilityValues || {}
            if (isCustomClearance) {
                setValues(keysToLoad.reduce((currentValues, key) => {
                    const parsedKey = parseCustomClearanceFieldKey(key)
                    if (!parsedKey) return currentValues
                    const clearanceItems = Array.isArray(record?.[parsedKey.recordKey])
                        ? record[parsedKey.recordKey]
                        : parsedKey.recordKey !== "importClearance" ? (Utils.extractCountry(bookingsStore.current?.contract?.portOfReceipt).toLowerCase() == 'india' ? exportIndia : exportNonIndia) : (Utils.extractCountry(bookingsStore.current?.contract?.finalPlaceOfDelivery).toLowerCase() === 'india') ? importIndia : importNonIndia
                    const dsrValue = clearanceItems[parsedKey.index]?.value
                    return {
                        ...currentValues,
                        [key]: (dsrValue !== undefined && dsrValue !== null && dsrValue !== "") ? dsrValue : (savedValues[key] ?? ""),
                    }
                }, {}))
            } else if (isContainerDetails) {
                const contractContainers = bookingsStore.current?.contract?.containerList || []
                const defaultContainers = contractContainers.length > 0
                    ? contractContainers.flatMap((item) => (
                        Array.from({ length: Number(item?.numContainers || 1) }, () => ({
                            container_types: item?.containerType || "",
                        }))
                    ))
                    : [{}]
                const containerSource = (Array.isArray(record?.containerlist) && record.containerlist.length > 0)
                    ? record.containerlist
                    : (savedValues.containerlist?.length > 0 ? savedValues.containerlist : defaultContainers)
                setValues({
                    containerlist: containerSource.map((container, index) => (
                        keysToLoad.reduce((containerValues, key) => ({
                            ...containerValues,
                            [key]: (container?.[key] !== undefined && container?.[key] !== null && container?.[key] !== "")
                                ? container[key]
                                : (savedValues.containerlist?.[index]?.[key] ?? ""),
                        }), { container_number: container?.container_number || container?.container_types || "" })
                    )),
                })
            } else if (isTransportUpdate) {
                let recordTransportRecords = currentTransportFieldName === "vorgin"
                    ? (record?.vorgin?.length ? record.vorgin : record?.vorgin)
                    : record?.[currentTransportFieldName]
                if (currentTransportFieldName === "vorgin" && recordTransportRecords === undefined) recordTransportRecords = [{origin:record.origin}]
                if (currentTransportFieldName === "vdes" && recordTransportRecords === undefined) recordTransportRecords = [{destination:record.destination}]
                const transportRecords = Array.isArray(recordTransportRecords) && recordTransportRecords.length > 0
                    ? recordTransportRecords
                    : savedValues.transportRecords?.length > 0 ? savedValues.transportRecords : [{}]
                setValues({
                    transportRecords: transportRecords.map((transport, index) => (
                        keysToLoad.reduce((transportValues, key) => ({
                            ...transportValues,
                            [key]: (transport?.[key] !== undefined && transport?.[key] !== null && transport?.[key] !== "")
                                ? transport[key]
                                : (savedValues.transportRecords?.[index]?.[key] ?? ""),
                        }), {})
                    )),
                })
            } else {
                const contractContainers = bookingsStore.current?.contract?.containerList || []
                const defaultContainers = contractContainers.length > 0
                    ? contractContainers.flatMap((item) => (
                        Array.from({ length: Number(item?.numContainers || 1) }, () => ({
                            container_types: item?.containerType || "",
                        }))
                    ))
                    : [{}]
                const containerSource = (Array.isArray(record?.containerlist) && record.containerlist.length > 0)
                    ? record.containerlist
                    : (savedValues.containerlist?.length > 0 ? savedValues.containerlist : defaultContainers)
                setValues({
                    ...keysToLoad.reduce((currentValues, key) => ({
                        ...currentValues,
                        [key]: (record?.[key] !== undefined && record?.[key] !== null && record?.[key] !== "")
                            ? record[key]
                            : (savedValues[key] ?? ""),
                    }), {}),
                    ...(containerKeysToLoad.length > 0 ? {
                        containerlist: containerSource.map((container, index) => (
                            containerKeysToLoad.reduce((containerValues, key) => ({
                                ...containerValues,
                                [key]: (container?.[key] !== undefined && container?.[key] !== null && container?.[key] !== "")
                                    ? container[key]
                                    : (savedValues.containerlist?.[index]?.[key] ?? ""),
                            }), { container_types: container?.container_types ?? "" })
                        )),
                    } : {}),
                })
            }
        }
        loadVisibilityValues()
    }, [displayedKeySignature, containerDisplayedKeySignature, isContainerDetails, isCustomClearance, isOriginTransport, isTransportUpdate, transportFieldName])

    const getDateInputValue = (value) => {
        if (!value) return ""
        const rawValue = String(value)
        if (/^\d{4}-\d{2}-\d{2}/.test(rawValue)) return rawValue.slice(0, 10)
        const dayFirstDate = rawValue.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/)
        if (dayFirstDate) return `${dayFirstDate[3]}-${dayFirstDate[2]}-${dayFirstDate[1]}`
        const parsedDate = new Date(rawValue)
        if (Number.isNaN(parsedDate.getTime())) return ""
        const year = parsedDate.getFullYear()
        const month = String(parsedDate.getMonth() + 1).padStart(2, "0")
        const day = String(parsedDate.getDate()).padStart(2, "0")
        return `${day}-${month}-${year}`
    }
    const getBackendDateValue = (value) => {
        if (!value) return "";
        const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return value;
        return `${match[3]}-${match[2]}-${match[1]}`;
    }
    const saveVisibilityUpdate = async (type) => {
        setSaving(true)
        taskStore.current.visibilityValues = values
        if (type === "Submit") {
        let ret = await Taskapi.getbookingdsr(taskStore.current.bookingNum)
        if (isCustomClearance) {
            const record = ret[0] || {}
            const updatedRecord = { ...record }
            Object.entries(values).forEach(([fieldKey, value]) => {
                const parsedKey = parseCustomClearanceFieldKey(fieldKey)
                if (!parsedKey) return
                const clearanceItems = Array.isArray(updatedRecord[parsedKey.recordKey])
                    ? updatedRecord[parsedKey.recordKey]
                    : parsedKey.recordKey !== "importClearance" ? (Utils.extractCountry(bookingsStore.current?.contract?.portOfReceipt).toLowerCase() == 'india' ? exportIndia : exportNonIndia) : (Utils.extractCountry(bookingsStore.current?.contract?.finalPlaceOfDelivery).toLowerCase() === 'india') ? importIndia : importNonIndia
                updatedRecord[parsedKey.recordKey] = clearanceItems.map((item, index) => (
                    index === parsedKey.index ? { ...item, value } : item
                ))
            })
            Api.apieditdsr(updatedRecord)
        } else if (isContainerDetails) {
            const record = ret[0]
            const targetContainers = (Array.isArray(record?.containerlist) && record.containerlist.length > 0)
                ? record.containerlist
                : (values.containerlist || [])
            Api.apieditdsr({
                ...record,
                containerlist: targetContainers.map((container, index) => ({
                    ...container,
                    ...(values.containerlist?.[index] || {}),
                })),
            })
        } else if (isTransportUpdate) {
            const record = ret[0] || {}
            const currentTransportFieldName = isOriginTransport
                ? Array.isArray(record.vorgin) ? "vorgin" : "vorgin"
                : transportFieldName
            const transportRecords = currentTransportFieldName === "vorgin"
                ? (record.vorgin?.length ? record.vorgin : record.vorgin || [{ origin: record.origin, total_package: bookingsStore.current?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0) }])
                : record[currentTransportFieldName] || [{ destination: record.destination, total_package: bookingsStore.current?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0)}]    
            const updatedTransportRecords = transportRecords.length > 0
                ? transportRecords.map((transport, index) => ({
                    ...transport,
                    ...(values.transportRecords?.[index] || {}),
                }))
                : values.transportRecords || []
            Api.apieditdsr({
                ...record,
                [currentTransportFieldName]: updatedTransportRecords,
            })
        } else {
            const record = ret[0]
            
            if (values?.pol_container_number || values?.reworking_pol_container_number || values?.reworking_pod_container_number){
                const CONTAINER_NUMBER_KEYS = [
                    "pol_container_number",
                    "reworking_pol_container_number",
                    "reworking_pod_container_number",
                ];

                const regex = /^[A-Z]{4}[0-9]{7}$/;
                for (const key of CONTAINER_NUMBER_KEYS) {
                    if (values?.[key]) { 
                        if (!regex.test(values[key])) {
                            setSaving(false);
                            setOpen(false);
                            return configStore.setModalMessage(
                                `Invalid Container No (e.g. ABCD1234567)`
                            );
                        }
                    }
                }
            }
            if (taskStore.current.shipmentType.includes('FCL') &&  values?.containerlist && taskStore.current?.visibilityContainerFields?.includes('container_number')) {
                const isValid = values?.containerlist?.every(
                    c => /^[A-Z]{4}[0-9]{7}$/.test(c.container_number)
                );
                setSaving(false)
                setOpen(false)
                if (!isValid) return configStore.setModalMessage("Invalid Container No (e.g. ABCD1234567)")
            }
            const targetContainers = (Array.isArray(record?.containerlist) && record.containerlist.length > 0)
                ? record.containerlist
                : (values.containerlist || [])
            Api.apieditdsr({
                ...record,
                ...values,
                ...(containerDisplayedKeys.length > 0 ? {
                    containerlist: targetContainers.map((container, index) => ({
                        ...container,
                        ...(values.containerlist?.[index] || {}),
                    })),
                } : {}),
            })
        }
            taskStore.current.stage = 2
            taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
            taskStore.setComplete()
    }
        await Taskapi.updateTask(taskStore.current)
        taskStore.triggerActionVisible = false
        taskStore.myActionVisible = false
        if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
            AgmodalStore.pageVisible = false
            AgmodalStore.apiCall = true
        }
        setSaving(false)
    }
    const disable = taskStore.current.stage == 2 ? true : false
    return (
        <div className="box" style={{width:"100%"}}>
            {open ? <Popup content={"Are you sure you want to update"} successBtn={"Confirm"} onClose={() => setOpen(false)} onSubmit={() => saveVisibilityUpdate("Submit")} /> : <></>}
            <h5 className="title is-5">Visibility Update</h5>
            <div className="columns is-multiline" >
                {isContainerDetails
                    ? (values.containerlist || []).map((container, containerIndex) => (
                        <div className="column is-full" key={`container-${containerIndex}`}>
                            <h6 className="title is-6">Container {container.container_number || containerIndex + 1}</h6>
                            <div className="columns is-multiline">
                                {fieldMetadata.map(({ key, dataType }) => (
                                    <div className="column is-one-third" key={key}>
                                        <div className="field">
                                            <label className="label is-small">
                                                {displayLabels[key] || key}{referenceKeys.includes(key) ? " (Reference)" : ""}
                                            </label>
                                            {dataType === "select" ? (
                                                <div className="control">
                                                    <div className="select is-fullwidth">
                                                        <select
                                                            value={container[key] || ""}
                                                            disabled={referenceKeys.includes(key) || disable}
                                                            onChange={(event) => {
                                                                const value = event.target.value
                                                                setValues((currentValues) => ({
                                                                    ...currentValues,
                                                                    containerlist: currentValues.containerlist.map((currentContainer, index) => (
                                                                        index === containerIndex
                                                                            ? { ...currentContainer, [key]: value }
                                                                            : currentContainer
                                                                    )),
                                                                }))
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {getOptionsValue(key, carrierList).map((option) => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            ) :
                                                (<div className="control">
                                                    <input
                                                        className="input"
                                                        type={dataType === "date" ? "date" : "text"}
                                                        value={dataType === "date" ? getDateInputValue(container[key]) : container[key] || ""}
                                                        disabled={referenceKeys.includes(key) || disable}
                                                        onChange={(event) => {
                                                            let value = event.target.value
                                                            if (dataType === "date") {
                                                                value = getBackendDateValue(value)
                                                            }
                                                            setValues((currentValues) => ({
                                                                ...currentValues,
                                                                containerlist: currentValues.containerlist.map((currentContainer, index) => (
                                                                    index === containerIndex
                                                                        ? { ...currentContainer, [key]: value }
                                                                        : currentContainer
                                                                )),
                                                            }))
                                                        }}
                                                    />
                                                </div>)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                    : isTransportUpdate
                        ? (values.transportRecords || []).map((transport, transportIndex) => (
                            <div className="column is-full" key={`transport-${transportIndex}`}>
                                <h6 className="title is-6">
                                    {isOriginTransport ? "Origin" : "Destination"} Transport {transportIndex + 1}
                                </h6>
                                <div className="columns is-multiline">
                                    {fieldMetadata.map(({ key, dataType }) => (
                                        <div className="column is-one-third" key={key}>
                                            <div className="field">
                                                <label className="label is-small">
                                                    {displayLabels[key] || key}{referenceKeys.includes(key) ? " (Reference)" : ""}
                                                </label>
                                                <div className="control">
                                                    {key === "transport_name"?
                                                        <OneInput5table
                                                            search={true}
                                                            name="transport_name"
                                                            record={JSON.parse(JSON.stringify(values?.transportRecords?.[transportIndex] || {}))}
                                                            onChange={(name, value) => {
                                                                setValues((currentValues) => ({
                                                                    ...currentValues,
                                                                    transportRecords: currentValues.transportRecords.map((currentTransport, index) =>
                                                                        index === transportIndex
                                                                            ? { ...currentTransport, [name]: value }
                                                                            : currentTransport
                                                                    ),
                                                                }));
                                                            }}
                                                        /> :
                                                    <input
                                                        className="input"
                                                        type={dataType === "date" ? "date" : "text"}
                                                        value={dataType === "date" ? getDateInputValue(transport[key]) : transport[key] || ""}
                                                        disabled={referenceKeys.includes(key) || disable}
                                                        onChange={(event) => {
                                                            let value = event.target.value
                                                            if (dataType === "date") {
                                                                value = getBackendDateValue(value)
                                                            }
                                                            setValues((currentValues) => ({
                                                                ...currentValues,
                                                                transportRecords: currentValues.transportRecords.map((currentTransport, index) => (
                                                                    index === transportIndex
                                                                        ? { ...currentTransport, [key]: value }
                                                                        : currentTransport
                                                                )),
                                                            }))
                                                        }}
                                                    />}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                        : <>
                            {fieldMetadata
                                .filter(({ key }) => displayedKeys.includes(key))
                                .map(({ key, dataType }) => (
                                    <div className="column is-one-third" key={key}>
                                        <div className="field">
                                            <label className="label is-small">
                                                {displayLabels[key] || key}{referenceKeys.includes(key) ? " (Reference)" : ""}
                                            </label>
                                            <div className="control">
                                                {dataType === "toggle" ? (<div className="field" style={{ textAlign: 'center' }}>
                                                    <div
                                                        className="control"
                                                        style={{ cursor: referenceKeys.includes(key) ? "not-allowed" : "pointer" }}
                                                    >
                                                        <div
                                                            onClick={referenceKeys.includes(key) || disable ? null : () => {
                                                                const value = String(values[key] || "").toLowerCase() === "yes" ? "No" : "Yes";
                                                                setValues((currentValues) => ({
                                                                    ...currentValues,
                                                                    [key]: value,
                                                                }));
                                                            }}
                                                        >
                                                            {String(values[key] || "").toLowerCase() === "yes" ? (
                                                                <img height='36px' width='36px' src={on} alt="on" />
                                                            ) : (
                                                                <img height='36px' width='36px' src={off} alt="off" />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>) :
                                                    dataType === "select" ? (
                                                        <div className="select is-fullwidth">
                                                            <select
                                                                value={values[key] || ""}
                                                                disabled={referenceKeys.includes(key) || disable}
                                                                onChange={(event) => {
                                                                    const value = event.target.value
                                                                    setValues((currentValues) => ({
                                                                        ...currentValues,
                                                                        [key]: value,
                                                                    }))
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {getOptionsValue(key, carrierList).map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        dataType === "datetime" ? (
                                                            <div style={{ display: "flex", gap: "8px" }}>
                                                                {/* Date Input */}
                                                                <input
                                                                    className="input"
                                                                    type="date"
                                                                    value={values[key] ? getDateInputValue(values[key].split("T")[0]) : ""}
                                                                    disabled={referenceKeys.includes(key) || disable}
                                                                    onChange={(event) => {
                                                                        const datePart = event.target.value;
                                                                        const timePart = values[key]?.split("T")[1] || "";
                                                                        setValues((currentValues) => ({
                                                                            ...currentValues,
                                                                            [key]: timePart ? `${datePart}T${timePart}` : datePart,
                                                                        }));
                                                                    }}
                                                                />

                                                                {/* Time Input */}
                                                                <input
                                                                    className="input"
                                                                    type="time"
                                                                    value={values[key] ? values[key].split("T")[1] : ""}
                                                                    disabled={referenceKeys.includes(key) || disable}
                                                                    onChange={(event) => {
                                                                        const timePart = event.target.value;
                                                                        const datePart = values[key]?.split("T")[0] || values[key] || "";
                                                                        if (datePart) {
                                                                            setValues((currentValues) => ({
                                                                                ...currentValues,
                                                                                [key]: `${datePart}T${timePart}`,
                                                                            }));
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            ) : (
                                                                <div>
                                                                    <input
                                                                        className="input"
                                                                        type={dataType === "date" ? "date" : "text"}
                                                                        value={dataType === "date" ? getDateInputValue(values[key]) : values[key] || ""}
                                                                        disabled={referenceKeys.includes(key) || disable}
                                                                        onChange={(event) => {
                                                                            let value = event.target.value;
                                                                            if (["pol_container_number", "reworking_pol_container_number", "reworking_pod_container_number"].includes(key)) value = value.toUpperCase();
                                                                            if(dataType === "date"){
                                                                                value = getBackendDateValue(value)
                                                                            }
                                                                            if (key.includes(":") && dataType === "date"){
                                                                                const parts = key.split(":").map(part => decodeURIComponent(part));
                                                                                if (parts[0] === "customClearance"){
                                                                                    value = getDateInputValue(value)
                                                                                }
                                                                            }
                                                                            setValues((currentValues) => ({
                                                                                ...currentValues,
                                                                                [key]: value,
                                                                            }));
                                                                        }}
                                                                    />

                                                                        {["pol_container_number", "reworking_pol_container_number", "reworking_pod_container_number"].includes(key) &&
                                                                    
                                                                        !/^[A-Z]{4}[0-9]{7}$/.test(values[key]) && (
                                                                            <p
                                                                                className="help is-danger"
                                                                                style={{ fontSize: "11px", marginTop: "4px" }}
                                                                            >
                                                                                Invalid format (e.g. ABCD1234567)
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            )
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            {containerDisplayedKeys.length > 0 && (values.containerlist || []).map((container, containerIndex) => (
                                <div className="column is-full" key={`container-${containerIndex}`}>
                                    <h6 className="title is-6">Container {container.container_types || containerIndex + 1}</h6>
                                    <div className="columns is-multiline">
                                        {createVisibilityFieldMetadata(containerDisplayedKeys).map(({ key, dataType }) => (
                                            <div className="column is-one-third" key={key}>
                                                <div className="field">
                                                    <label className="label is-small">
                                                        {dsrstatic_cn[key] || key}{containerReferenceKeys.includes(key) ? " (Reference)" : ""}
                                                    </label>
                                                    <div className="control">
                                                        <input
                                                            className={`input ${key === "container_number" && container[key] &&
                                                                    !/^[A-Z]{4}[0-9]{7}$/.test(container[key])
                                                                    ? "is-danger" : ""
                                                                }`}                                                            type={dataType === "date" ? "date" : "text"}
                                                            value={dataType === "date" ? getDateInputValue(container[key]) : container[key] || ""}
                                                            disabled={containerReferenceKeys.includes(key) || disable}
                                                            onChange={(event) => {
                                                                let value = event.target.value
                                                                if(key === "container_number"){
                                                                    value = value.toUpperCase();
                                                                }
                                                                if (dataType === "date") {
                                                                    value = getBackendDateValue(value)
                                                                }
                                                                setValues((currentValues) => ({
                                                                    ...currentValues,
                                                                    containerlist: currentValues.containerlist.map((currentContainer, index) => (
                                                                        index === containerIndex
                                                                            ? { ...currentContainer, [key]: value }
                                                                            : currentContainer
                                                                    )),
                                                                }))
                                                            }}
                                                        />
                                                        {key === "container_number" && container[key] &&
                                                            !/^[A-Z]{4}[0-9]{7}$/.test(container[key]) && (
                                                                <p
                                                                    className="help is-danger"
                                                                    style={{ fontSize: "11px", marginTop: "4px" }}
                                                                >
                                                                    Invalid format (e.g. ABCD1234567)
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </>}
            </div>
            {
                !disable &&
                <div style={{ display: 'flex', justifyContent: "flex-end", gap: "10px" }}>
                    <button
                        type="button"
                        className="button is-link"
                        disabled={saving}
                        onClick={() => {
                            saveVisibilityUpdate("Save")
                        }}
                    >
                        {saving ? "Saving..." : "Save"}
                    </button>
                    <button
                        type="button"
                        className="button is-link"
                        disabled={saving || !isFormComplete}
                        onClick={() => {
                            setOpen(true)
                            // saveVisibilityUpdate("Submit")
                        }}
                    >
                        Submit
                    </button>
                </div>
            }
        </div>
    )
}

export function VisibilityUpdateTrigger() {
    const [visibilityUpdateTriggerOptions, setVisibilityUpdateTriggerOptions] = useState([
        "P2P",
        "Origin Custom",
        "Destination Custom",
    ])
    const [fields, setFields] = useState([])
    const [referenceKeys, setReferenceKeys] = useState([])
    const [actionKeys, setActionKeys] = useState([])
    const [selectedTrigger, setSelectedTrigger] = useState(taskStore.current?.visibilityUpdateTrigger || "")
    useEffect(() => {
        async function fetchBookingDSR() {
            let dsr = await MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, {
                _id: bookingsStore.current?._id
            })
            const dsrRecord = Array.isArray(dsr) ? dsr[0] : undefined
            const shipmentType = taskStore.current?.shipmentType || bookingsStore.current?.shipmentType || dsrRecord?.shipmentType || ""
            const shipmentScope = taskStore.current?.shipmentScope || bookingsStore.current?.shipmentScope || dsrRecord?.shipmentScope || ""
            const por = taskStore.current.por || bookingsStore.current?.por || dsrRecord?.por || ""
            const pol = taskStore.current.pol || bookingsStore.current?.pol || dsrRecord?.pol || ""
            const pod = taskStore.current.pod || bookingsStore.current?.pod || dsrRecord?.pod || ""
            const fpod = taskStore.current.fpod || bookingsStore.current?.fpod || dsrRecord?.fpod || ""

            let fieldLabels = {}
            let fieldKeys = []
            let arr = ["gatein_pol", "gatein_fpod", "container_pickup_fpod", "empty_return"]
            const options = ["P2P", "Origin Custom", "Destination Custom"];
            if (!options.includes("Origin Transport") &&
                ((shipmentType === "FCL (Dock/Factory)" && (shipmentScope === "Door-to-Port" || shipmentScope === "Door-to-Door")) ||
                    (shipmentType === "FCL (Dock/Dock)" && (shipmentScope === "Door-to-Port" || shipmentScope === "Door-to-Door")) ||
                    (['LCL', 'Air'].includes(shipmentType) && ((shipmentScope === "Door-to-Port" || shipmentScope === "Door-to-Door")))
                )
            ) {
                options.push("Origin Transport");
            }
            if (!options.includes("Destination Transport") &&
                ((shipmentType === "FCL (Factory/Dock)" && (shipmentScope === "Port-to-Door" || shipmentScope === "Door-to-Door")) ||
                    (shipmentType === "FCL (Dock/Dock)" && (shipmentScope === "Port-to-Door" || shipmentScope === "Door-to-Door")) ||
                    (['LCL', 'Air'].includes(shipmentType) && ((shipmentScope === "Port-to-Door" || shipmentScope === "Door-to-Door")))
                )
            ) {
                options.push("Destination Transport");
            }
            setVisibilityUpdateTriggerOptions(options);
            if (selectedTrigger === "Origin Custom" || selectedTrigger === "Destination Custom") {
                const isOriginCustom = selectedTrigger === "Origin Custom"
                let clearanceRecordKeys = isOriginCustom
                    ? getExportClearanceRecordKeys(dsrRecord)
                    : Array.isArray(dsrRecord?.importClearance) ? ["importClearance"] : []
                if (clearanceRecordKeys.length === 0) {
                    clearanceRecordKeys = [isOriginCustom ? "exportClearance" : "importClearance"]
                }
                clearanceRecordKeys.forEach((recordKey) => {
                    const clearanceItems = Array.isArray(dsrRecord?.[recordKey])
                        ? dsrRecord[recordKey]
                        : isOriginCustom ? (Utils.extractCountry(bookingsStore.current?.contract?.portOfReceipt).toLowerCase() == 'india' ? exportIndia : exportNonIndia) : (Utils.extractCountry(bookingsStore.current?.contract?.finalPlaceOfDelivery).toLowerCase() === 'india') ? importIndia : importNonIndia
                    clearanceItems.forEach((item, index) => {
                        if (!item?.label) return
                        const fieldKey = createCustomClearanceFieldKey(recordKey, index, item.label)
                        fieldLabels[fieldKey] = item.label
                        fieldKeys.push(fieldKey)
                    })
                })
            } else if (shipmentType === "FCL (Factory/Factory)") {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_FCLFactoryFactory
                    fieldKeys = dsrstatic_FCLFactoryFactory_keys
                    const k = Object.keys(fieldLabels)
                    const l = {}
                    for (let i = 0; i < k.length; i++) {
                        l[k[i]] = dsrstatic_FCLFactoryFactory[k[i]]
                    }
                    fieldLabels = l
                    if (pod !== fpod) {
                        fieldLabels["eta_at_pod"] = "ETA @ POD"
                        fieldLabels["pod_arrival"] = "ATA @ POD"
                        fieldLabels["etd_pod"] = "ETD from POD"
                    }
                    fieldLabels = myactionsstore.addts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_fcl_FACTORY_FACTORY
                    fieldKeys = destination_delivery_fcl_FACTORY_FACTORY_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_fcl_FACTORY_FACTORY
                    fieldKeys = origin_pickup_fcl_FACTORY_FACTORY_Keys
                }
            } else if (shipmentType === "FCL (Dock/Factory)") {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_FCLDockFactory
                    fieldKeys = dsrstatic_FCLDockFactory_keys
                    if (pod !== fpod) {
                        fieldLabels["eta_at_pod"] = "ETA @ POD"
                        fieldLabels["pod_arrival"] = "ATA @ POD"
                        fieldLabels["etd_pod"] = "ETD from POD"
                    }
                    fieldLabels = myactionsstore.addts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_fcl_CFS_FACTORY
                    fieldKeys = destination_delivery_fcl_CFS_FACTORY_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_fcl_CFS_FACTORY
                    fieldKeys = origin_pickup_fcl_CFS_FACTORY_Keys
                }
            } else if (shipmentType === "FCL (Factory/Dock)") {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_FCLFactoryDock
                    fieldKeys = dsrstatic_FCLFactoryDock_keys
                    if (pod !== fpod) {
                        fieldLabels["eta_at_pod"] = "ETA @ POD"
                        fieldLabels["pod_arrival"] = "ATA @ POD"
                        fieldLabels["etd_pod"] = "ETD from POD"
                    }
                    fieldLabels = myactionsstore.addts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_fcl_FACTORY_CFS
                    fieldKeys = destination_delivery_fcl_FACTORY_CFS_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_fcl_FACTORY_CFS
                    fieldKeys = origin_pickup_fcl_FACTORY_CFS_Keys
                }
            } else if (shipmentType === "FCL (Dock/Dock)") {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_FCLDockDock
                    fieldKeys = dsrstatic_FCLDockDock_keys
                    if (pod !== fpod) {
                        fieldLabels["eta_at_pod"] = "ETA @ POD"
                        fieldLabels["pod_arrival"] = "ATA @ POD"
                        fieldLabels["etd_pod"] = "ETD from POD"
                    }
                    fieldLabels = myactionsstore.addts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_fcl_CFS_CFS
                    fieldKeys = destination_delivery_fcl_CFS_CFS_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_fcl_CFS_CFS
                    fieldKeys = origin_pickup_fcl_CFS_CFS_Keys
                }
            } else if (shipmentType.toLowerCase().includes("lcl")) {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_LCL
                    fieldKeys = dsrstatic_LCL_keys
                    if (shipmentScope !== "Port-to-Door" && shipmentScope !== "Port-to-Port") {
                        fieldKeys = fieldKeys.filter(e => e !== "cargo_gatein_CFS");
                    }
                    if (por !== pol) {
                        fieldLabels['container_handover']= "Container Handover"
                        fieldLabels['por_to_pol_movement'] = 'Rail-out / Truck-out Status'
                        fieldLabels['reworking_at_pol'] = 'Re-working at POL ?'
                        if (!fieldKeys.includes('reworking_at_pol')) fieldKeys.push('reworking_at_pol')
                    }
                    if (!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.DETAILED_LCL_VISIBILITY)){
                        fieldKeys = fieldKeys.filter(e => !["agentSeal", "customsSeal", "cust_ref_number", "agraga_booking_#", 'reworking_pol_destuffing', "reworking_pol_restuffing", "reworking_pod_destuffing", "reworking_pod_restuffing","remarks"].includes(e))
                    }
                    if (!(dsrRecord?.reworking_pol_port || dsrRecord?.reworking_pod_port)){
                        fieldKeys = fieldKeys.filter(e => e !== "new_carrier_name" && e !== "new_carrier_mbl_number")
                    }
                    if (pod !== fpod) {
                        fieldLabels['eta_at_pod'] = "ETA @ POD"
                        fieldLabels['pod_arrival'] = "ATA @ POD"
                        fieldLabels['etd_pod'] = "ETD from POD"
                        fieldLabels['gateout_to_fpod'] = "Gate-out from POD"
                        fieldLabels['reworking_at_pod'] = 'Re-working at POD ?'
                        if (!fieldKeys.includes('reworking_at_pod')) fieldKeys.push('reworking_at_pod')
                    }
                    if (!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.DETAILED_LCL_VISIBILITY) ||
                        bookingsStore.current.contract.fbaOCC !== "No"
                    ) {
                            fieldKeys = fieldKeys.filter(e => e !== 'leo_cutoff');
                    }
                    if (!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.DETAILED_LCL_VISIBILITY)) fieldKeys = fieldKeys.filter(e => e !== 'stuffing_cutoff');
                    if (dsrRecord?.reworking_at_pol?.toLowerCase() == 'yes'){
                        // fieldLabels['reworking_at_pol'] = 'Yes'
                        fieldLabels['rail_yard_to_cfs'] = "Movement from Rail Yard to POL CFS"
                        fieldLabels['destuffing_at_pol'] = "De-stuffing Status"
                        fieldLabels['restuffing_at_pol'] = "Re-stuffing Status"
                    }else{
                        delete fieldLabels['rail_yard_to_cfs'];
                        delete fieldLabels['destuffing_at_pol'];
                        delete fieldLabels['restuffing_at_pol'];
                    }
                    const reworkingPodKeys = [
                        'reworking_pod_arrival_estimate',
                        'reworking_pod_arrival',
                        'reworking_pod_departure_estimate',
                        'reworking_pod_departure',
                        'reworking_pod_vessel_name',
                        'reworking_pod_vessel_number',
                        'reworking_pod_container_number',
                        'reworking_pod_destuffing',
                        'reworking_pod_restuffing',
                    ];
                    if (!dsrRecord?.reworkingPort) fieldKeys = fieldKeys.filter(e => e != "reworkingPort")

                    if (dsrRecord?.reworking_at_pod?.toLowerCase() === 'yes') {
                        // fieldLabels['reworking_at_pod'] = 'Yes';
                        fieldLabels['reworking_pod_arrival_estimate'] = "Reworking POD Arrival Estimate";
                        fieldLabels['reworking_pod_arrival'] = "Reworking POD Arrival";
                        fieldLabels['reworking_pod_departure_estimate'] = "Reworking POD Departure Estimate";
                        fieldLabels['reworking_pod_departure'] = "Reworking POD Departure";
                        fieldLabels['reworking_pod_vessel_name'] = "Reworking POD Vessel Name";
                        fieldLabels['reworking_pod_vessel_number'] = "Reworking POD Vessel Number";
                        fieldLabels['reworking_pod_container_number'] = "Reworking POD Container Number";
                        fieldLabels['reworking_pod_destuffing'] = "Reworking POD De-stuffing";
                        fieldLabels['reworking_pod_restuffing'] = "Reworking POD Re-stuffing";
                    } else {
                        reworkingPodKeys.forEach(key => delete fieldLabels[key]);
                    }
                    if (["Door-to-Port", "Port-to-Port"].includes(shipmentScope)) {
                        fieldLabels['cargo_picked_up_by_consignee'] = "Cargo Picked-up by Consignee"
                    }else{
                        delete fieldLabels['cargo_picked_up_by_consignee']   
                    }
                    fieldLabels = myactionsstore.addts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_LCL
                    fieldKeys = destination_delivery_LCL_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_LCL
                    fieldKeys = origin_pickup_LCL_Keys
                }
            } else if (shipmentType.toLowerCase().includes("air")) {
                if (selectedTrigger === "P2P") {
                    fieldLabels = dsrstatic_Air
                    fieldKeys = dsrstatic_Air_keys
                    if (shipmentScope !== "Port-to-Door" && shipmentScope !== "Port-to-Port") {
                        fieldKeys = fieldKeys.filter(e => e !== "arrival_dispatch_airport");
                    }
                    fieldLabels = myactionsstore.addairts(fieldLabels, dsr[0])
                } else if (selectedTrigger === "Destination Transport") {
                    fieldLabels = destination_delivery_AIR
                    fieldKeys = destination_delivery_AIR_Keys
                } else if (selectedTrigger === "Origin Transport") {
                    fieldLabels = origin_pickup_AIR
                    fieldKeys = origin_pickup_AIR_Keys
                }
            }
            if (selectedTrigger === "Destination Transport" && dsrRecord?.transportTypeDestination === 'DRAYAGE' && !shipmentType.toLowerCase().includes("air")) {
                delete fieldLabels['loaded_cfs'];
                fieldKeys = fieldKeys.filter(key => key !== 'loaded_cfs');
            }
            if (shipmentType.includes("FCL")) {                
                if (!["Port-to-Door", "Port-to-Port"].includes(shipmentScope) ||
                    bookingsStore.current?.contract?.stuffingType !== "Dock") fieldKeys = fieldKeys.filter(e => e !="cargo_gatein_CFS")
                if (por != pol) {
                   fieldKeys = fieldKeys.filter(e => !['gate_opening', "gate_cut_off"].includes(e))
                }
                if (por === pol) fieldKeys = fieldKeys.filter(e => "container_gate_cut_off"!=e)
                if (!dsrRecord?.fpod?.startsWith("US")) fieldKeys = fieldKeys.filter(e => !['ams_cutoff','isf_cutoff'].includes(e))
            }
            fieldKeys = Utils.filterDestinationKeys(fieldKeys, pod, fpod)
            if (fieldKeys.includes('container_discharged_pod')) {
                fieldLabels = { ...fieldLabels, container_discharged_pod: Utils.containerDischargedLabel(pod, fpod) }
            }
            if (TenantUtils.isAgraga()) {
                fieldKeys = fieldKeys.filter(e => e !== "delivery_order_status" && e !== "do_remarks")
            }
            fieldKeys = fieldKeys.filter(e => e !== "status_closed" && !OCEAN_TRACKING_DSR_KEYS.includes(e))
            const hasValue = (value) => {
                if (value === undefined || value === null) return false
                if (typeof value === "string") return value.trim().length > 0
                if (Array.isArray(value)) return value.length > 0
                if (typeof value === "object") return Object.keys(value).length > 0
                return true
            }

            let eligibleKeys = fieldKeys.filter((fieldKey) => {
                const transshipmentMatch = fieldKey.match(/^ts([1-4])_/)
                if (transshipmentMatch) {
                    const transshipmentPort = `ts${transshipmentMatch[1]}_port`
                    if (!hasValue(dsrRecord?.[transshipmentPort])) return false
                }
                const reworkingPolMatch = fieldKey.match(/^reworking_pol_/)
                if (reworkingPolMatch && !hasValue(dsrRecord?.reworking_pol_port)) return false
                const reworkingPodMatch = fieldKey.match(/^reworking_pod_/)
                if (reworkingPodMatch && !hasValue(dsrRecord?.reworking_pod_port)) return false
                const sharedReworkingMatch = fieldKey.match(/^reworking_(?!pol_|pod_|at_(?:pol|pod)$)/)
                if (sharedReworkingMatch
                    && !hasValue(dsrRecord?.reworking_pol_port)
                    && !hasValue(dsrRecord?.reworking_pod_port)) {
                    return false
                }
                return true
            })
            const hasValueInAllContainers = (fieldKey) => {
                return (
                    // dsrRecord?.containerlist &&
                    // dsrRecord.containerlist.length > 0 &&
                    dsrRecord?.containerlist?.every(
                        (container) => hasValue(container[fieldKey])
                    )
                );
            };
            let populatedKeys
            let emptyKeys
            if (selectedTrigger === "Origin Custom" || selectedTrigger === "Destination Custom") {
                const customClearanceKeys = eligibleKeys.filter((fieldKey) => fieldLabels[fieldKey])
                populatedKeys = customClearanceKeys.filter((fieldKey) => {
                    const parsedKey = parseCustomClearanceFieldKey(fieldKey);
                    return hasValue(dsrRecord?.[parsedKey.recordKey]?.[parsedKey.index]?.value);
                });
                emptyKeys = customClearanceKeys.filter((fieldKey) => {
                    const parsedKey = parseCustomClearanceFieldKey(fieldKey)
                    return !hasValue(dsrRecord?.[parsedKey.recordKey]?.[parsedKey.index]?.value)
                })
            } else if (selectedTrigger === "Destination Transport") {
                eligibleKeys.push('origin')
                fieldLabels["origin"] = "Origin"
                eligibleKeys.push('destination')
                fieldLabels["destination"] = "Destination"
                let transportRecords = dsrRecord?.vdes || [{ destination: dsrRecord.destination }]
                if (dsrRecord?.multidest?.length > 1) {
                    transportRecords = []
                    for (let i = 0; i < dsrRecord.multidest.length; i++) {
                        const key = i === 0 ? "vdes" : `vdes${i + 1}`
                        if (Array.isArray(dsrRecord[key])) {
                            transportRecords.push(...dsrRecord[key])
                        }
                    }
                }
                populatedKeys = eligibleKeys.filter((fieldKey) =>
                    transportRecords.length > 0
                    && transportRecords.every((record) => hasValue(record[fieldKey]))
                )
                emptyKeys = transportRecords.length === 0
                    ? eligibleKeys
                    : eligibleKeys.filter((fieldKey) =>
                        transportRecords.some((record) => !hasValue(record[fieldKey]))
                    )
            } else if (selectedTrigger === "Origin Transport") {
                eligibleKeys.push('origin')
                fieldLabels["origin"] = "Origin"
                eligibleKeys.push('destination')
                fieldLabels["destination"] = "Destination"
                const transportRecords = Array.isArray(dsrRecord?.vorgin) && dsrRecord.vorgin.length > 0
                    ? dsrRecord.vorgin
                    : dsrRecord?.vorgin || [{origin:dsrRecord.origin}]
                populatedKeys = eligibleKeys.filter((fieldKey) =>
                    transportRecords.length > 0
                    && transportRecords.every((record) => hasValue(record[fieldKey]))
                )
                emptyKeys = transportRecords.length === 0
                    ? eligibleKeys
                    : eligibleKeys.filter((fieldKey) =>
                        transportRecords.some((record) => !hasValue(record[fieldKey]))
                    )
            } else {
                const obj = Object.keys(fieldLabels)
                eligibleKeys = eligibleKeys.filter(e => obj.includes(e))
                populatedKeys = eligibleKeys.filter((fieldKey) => hasValue(dsrRecord?.[fieldKey]))
                emptyKeys = eligibleKeys.filter((fieldKey) => !hasValue(dsrRecord?.[fieldKey]))
            }

            if (selectedTrigger === "P2P" && shipmentType.includes("FCL") ) {
                let containerKeys = Object.keys(dsrstatic_cn)
                let keys
                if ("FCL (Factory/Factory)" == shipmentType) {
                    keys = dsrstatic_FCLFactoryFactory_keys
                }

                if ("FCL (Dock/Factory)" == shipmentType) {
                    keys = dsrstatic_FCLDockFactory_keys
                }

                if ("FCL (Factory/Dock)" == shipmentType) {
                    keys = dsrstatic_FCLFactoryDock_keys
                }
                if ("FCL (Dock/Dock)" == shipmentType) {
                    keys = dsrstatic_FCLDockDock_keys
                }
                if (shipmentScope == "Port-to-Door" || shipmentScope == "Door-to-Door") {
                    arr.push("estimate_delivery_date_to_consignee")
                    arr.push("container_delivery")
                    arr.push("container_arrival_at_fpod")
                    arr.push("container_de_vanning")
                }
                if (shipmentScope == "Door-to-Port" || shipmentScope == "Door-to-Door") {
                    arr.push("empty_container_pickup")
                    arr.push("container_arrival_factory")
                    arr.push("loaded_and_dispatch")
                    arr.push("stuffing_confirmation")
                }
                if (por != pol) {
                    arr.push("container_handover")
                    arr.push("por_to_pol_movement")
                }
                if (pod != fpod) {
                    arr.push("gateout_to_fpod")
                }
                containerKeys = keys.filter(e => arr.includes(e))
                containerKeys = [...containerKeys, "container_types", "container_number", "agentSeal","customsSeal"]
                const hasContainers = dsrRecord?.containerlist && dsrRecord.containerlist.length > 0
                const containerReferenceKeys = hasContainers
                    ? [
                        `${containerFieldPrefix}container_types`,
                        ...containerKeys
                            .filter(key => key !== "container_types")
                            .filter(hasValueInAllContainers)
                            .map(fieldKey => `${containerFieldPrefix}${fieldKey}`)
                    ]
                    : [`${containerFieldPrefix}container_types`];

                const containerActionKeys = hasContainers
                    ? containerKeys
                        .filter(key => key !== "container_types")
                        .filter(fieldKey => dsrRecord.containerlist.some(container => !hasValue(container[fieldKey])))
                        .map(fieldKey => `${containerFieldPrefix}${fieldKey}`)
                    : containerKeys
                        .filter(key => key !== "container_types")
                        .map(fieldKey => `${containerFieldPrefix}${fieldKey}`);               
                populatedKeys = [...populatedKeys, ...containerReferenceKeys]
                emptyKeys = [...emptyKeys, ...containerActionKeys]
                fieldLabels = {
                    ...fieldLabels,
                    ...Object.fromEntries(containerKeys.map((fieldKey) => [
                        `${containerFieldPrefix}${fieldKey}`,
                        dsrstatic_cn[fieldKey],
                    ])),
                }
            }

            setFields(fieldLabels)
            setReferenceKeys(populatedKeys)
            setActionKeys(emptyKeys)

        }
        fetchBookingDSR()
    }, [selectedTrigger])

    const [selectedFields, setSelectedFields] = useState(() => (
        [...new Set([
            ...(taskStore.current?.referenceKey || []),
            ...(taskStore.current?.[visibilityFieldName] || []),
            ...(taskStore.current?.[containerReferenceFieldName] || []).map((key) => `${containerFieldPrefix}${key}`),
            ...(taskStore.current?.[containerVisibilityFieldName] || []).map((key) => `${containerFieldPrefix}${key}`),
        ])]
    ))

    const selectableKeys = [...referenceKeys, ...actionKeys]
    const allFieldsSelected = selectableKeys.length > 0
        && selectableKeys.every((fieldKey) => selectedFields.includes(fieldKey))

    const toggleField = (fieldKey) => {
        setSelectedFields((currentFields) => (
            currentFields.includes(fieldKey)
                ? currentFields.filter((key) => key !== fieldKey)
                : [...currentFields, fieldKey]
        ))
    }

    const toggleAllFields = () => {
        setSelectedFields(allFieldsSelected ? [] : selectableKeys)
    }

    const toggleSection = (sectionKeys) => {
        const sectionIsSelected = sectionKeys.length > 0
            && sectionKeys.every((fieldKey) => selectedFields.includes(fieldKey))
        setSelectedFields((currentFields) => sectionIsSelected
            ? currentFields.filter((fieldKey) => !sectionKeys.includes(fieldKey))
            : [...new Set([...currentFields, ...sectionKeys])]
        )
    }

    const renderFieldSection = (title, sectionKeys) => {
        const sectionIsSelected = sectionKeys.length > 0
            && sectionKeys.every((fieldKey) => selectedFields.includes(fieldKey))

        return (
            <section className="mb-5" key={title}>
                <div className="is-flex is-justify-content-space-between is-align-items-center mb-2">
                    <h6 className="title is-6 mb-0">{title}</h6>
                    {selectedTrigger &&
                        <label className="checkbox">
                            <input
                                type="checkbox"
                                checked={sectionIsSelected}
                                disabled={sectionKeys.length === 0}
                                onChange={() => toggleSection(sectionKeys)}
                            />
                            <span className="ml-2">Select all {title.toLowerCase()}</span>
                        </label>}
                </div>
                {sectionKeys.length > 0 ? (
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "8px",
                    }}>
                        {sectionKeys.map((fieldKey) => (
                            <label
                                key={fieldKey}
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "9px",
                                    flex: "0 1 calc(25% - 8px)",
                                    minWidth: "180px",
                                    boxSizing: "border-box",
                                    padding: "10px 12px",
                                    border: `1px solid ${selectedFields.includes(fieldKey) ? "#6675c2" : "#d9deea"}`,
                                    borderRadius: "4px",
                                    backgroundColor: selectedFields.includes(fieldKey) ? "#f1f3fc" : "#fff",
                                    cursor: "pointer",
                                    lineHeight: 1.35,
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedFields.includes(fieldKey)}
                                    onChange={() => toggleField(fieldKey)}
                                    style={{ flex: "0 0 auto", marginTop: "2px" }}
                                />
                                <span style={{ overflowWrap: "anywhere", fontSize: "13px" }}>
                                    {fields[fieldKey] || fieldKey}
                                </span>
                            </label>
                        ))}
                    </div>
                ) : (
                    <p className="has-text-grey is-size-7">No {title.toLowerCase()} available.</p>
                )}
            </section>
        )
    }

    const saveVisibilityFields = async () => {
        const selectedReferenceKeys = selectedFields.filter((key) => referenceKeys.includes(key) && !key.startsWith(containerFieldPrefix))
        const selectedActionKeys = selectedFields.filter((key) => actionKeys.includes(key) && !key.startsWith(containerFieldPrefix))
        const selectedContainerReferenceKeys = selectedFields
            .filter((key) => referenceKeys.includes(key) && key.startsWith(containerFieldPrefix))
            .map((key) => key.slice(containerFieldPrefix.length))
        const selectedContainerFields = selectedFields
            .filter((key) => actionKeys.includes(key) && key.startsWith(containerFieldPrefix))
            .map((key) => key.slice(containerFieldPrefix.length))
        taskStore.current.visibilityUpdateTrigger = selectedTrigger
        taskStore.current.referenceKey = selectedReferenceKeys
        taskStore.current[visibilityFieldName] = selectedActionKeys
        taskStore.current[containerReferenceFieldName] = selectedContainerReferenceKeys
        taskStore.current[containerVisibilityFieldName] = selectedContainerFields
        taskStore.current.stage = 1
        taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
        taskStore.current.status = 'PENDING'
        const actionList = await MonApi.apost(GET_PENDING_MYACTIONS_URI, {
            bookingNum: taskStore.current.bookingNum,
        });
        const existingTask = actionList?.find((item) => item.visibilityUpdateTrigger === selectedTrigger)
        if (existingTask) {
            const actionFieldKeys = new Set(actionKeys.filter((key) => !key.startsWith(containerFieldPrefix)))
            existingTask.referenceKey = [
                ...new Set([
                    ...(existingTask.referenceKey || []),
                    ...selectedReferenceKeys,
                ]),
            ].filter((key) => !actionFieldKeys.has(key))
            existingTask[visibilityFieldName] = [
                ...new Set([
                    ...(existingTask[visibilityFieldName] || []),
                    ...selectedActionKeys,
                ]),
            ]
            existingTask[containerReferenceFieldName] = selectedContainerReferenceKeys
            existingTask[containerVisibilityFieldName] = selectedContainerFields
            existingTask.visibilityUpdateTrigger = selectedTrigger
            taskStore.current = JSON.parse(JSON.stringify(existingTask))
            await Taskapi.updateTask(taskStore.current)
            taskStore.triggerActionVisible = false
            taskStore.myActionVisible = false
            if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                AgmodalStore.pageVisible = false
                AgmodalStore.apiCall = true
            }
        } else {
            await Taskapi.saveTask(taskStore.current)
        }
    }

    return (
        <div className="box">
            <div className="level mb-3">
                <div className="level-left">
                    <div>
                        <h5 className="title is-5 mb-1">Visibility Update</h5>
                        <p className="is-size-7 has-text-grey">
                            Select the {taskStore.current?.shipmentType} fields to make visible.
                        </p>
                        <div className="field mt-3">
                            <label className="label is-small" >Select Milestone Type</label>
                            <div className="control">
                                <div className="select">
                                    <select
                                        value={selectedTrigger}
                                        onChange={(event) => setSelectedTrigger(event.target.value)}
                                    >
                                        <option value="">Select a type</option>
                                        {visibilityUpdateTriggerOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="level-right">
                    {selectedTrigger &&
                        <label className="checkbox">
                            <input
                                type="checkbox"
                                checked={allFieldsSelected}
                                onChange={toggleAllFields}
                            />
                            <span className="ml-2">Select all</span>
                        </label>}
                </div>
            </div>
            {renderFieldSection("Reference Keys", referenceKeys)}
            {renderFieldSection("Action Keys", actionKeys)}
            <div className="has-text-right mt-3">
                <button
                    type="button"
                    className="button is-link"
                    disabled={!selectedTrigger}
                    onClick={saveVisibilityFields}
                >
                    Trigger
                </button>
            </div>
        </div>
    )
}